var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _TextAreaController_lengthDisplayRoots;
import { CurrentFromMaxDisplayObserver, CurrentFromMaxDisplaySubject, rootWithComponent, } from "@core/react-components";
import { Controller } from "@hotwired/stimulus";
class TextAreaController extends Controller {
    constructor() {
        super(...arguments);
        // instance
        _TextAreaController_lengthDisplayRoots.set(this, new WeakMap());
    }
    initialize() {
        this.lengthDisplaySubject = new CurrentFromMaxDisplaySubject();
    }
    lengthDisplayOutletConnected(outlet, element) {
        const root = rootWithComponent(element, CurrentFromMaxDisplayObserver, {
            atMaxClass: this.atMaxClasses.join(" "),
            initial: this.element.value.length,
            max: this.element.maxLength,
            subject: this.lengthDisplaySubject,
        });
        __classPrivateFieldGet(this, _TextAreaController_lengthDisplayRoots, "f").set(outlet, root);
    }
    lengthDisplayOutletDisconnected(outlet) {
        __classPrivateFieldGet(this, _TextAreaController_lengthDisplayRoots, "f").get(outlet)?.unmount();
        __classPrivateFieldGet(this, _TextAreaController_lengthDisplayRoots, "f").delete(outlet);
    }
    connect() {
        this.validate();
    }
    updateLengthDisplay() {
        this.lengthDisplaySubject.notify(this.element.value.length);
    }
    validate() {
        this.element.setCustomValidity("");
        const content = this.element.value.trim();
        if (content === "") {
            this.element.setCustomValidity(this.emptyErrorValue);
            return;
        }
    }
}
_TextAreaController_lengthDisplayRoots = new WeakMap();
TextAreaController.values = {
    emptyError: String,
};
TextAreaController.classes = ["atMax"];
TextAreaController.outlets = ["length-display"];
export default TextAreaController;
//# sourceMappingURL=textarea_controller.js.map